export default {
  leads: [],
  desempenho: [],
  rankNovos: [],
  rankLeads: [],
  rankUsados: [],
  rankConsorcio: [],
  historicoRank: [],
  empresas: []
}
